export default "__VITE_ASSET__CxuxdBtZ__"